/**
 * The Amateur's Code
 * Written by Paul M. Segal, W9EEA, in 1928
 */

import coverImg from '../../../assets/images/literature/amateurs-code-cover.jpg';

const SEGMENTS = [
    {
        id: 'amateurs-code-1',
        title: "The Radio Amateur's Code",
        text: `The Radio Amateur's Code
- adapted from the original Amateur's Code, written by Paul M. Segal, W9EEA, in 1928

The Radio Amateur is

CONSIDERATE...The radio amateur never knowingly operates in such a way as to lessen the pleasure of others.

LOYAL...The radio amateur offers loyalty, encouragement and support to other amateurs, local clubs, the IARU Radio Society in their country, through which Amateur Radio in their country is represented nationally and internationally.

PROGRESSIVE...The radio amateur keeps their station up to date. It is well-built and efficient. Their operating practice is above reproach.

FRIENDLY...The radio amateur operates slowly and patiently when requested; offers friendly advice and counsel to beginners; kind assistance, cooperation and consideration for the interests of others. These are the marks of the amateur spirit.

BALANCED...Radio is a hobby, never interfering with duties owed to family, job, school or community.

PATRIOTIC...The radio amateur's station and skills are always ready for service to country and community.`,
        morseText: `| | | THE RADIO AMATEUR'S CODE BK ADAPTED FROM THE ORIGINAL AMATEUR'S CODE WRITTEN BY PAUL M SEGAL W9EEA IN 1928 BK THE RADIO AMATEUR IS BK CONSIDERATE THE RADIO AMATEUR NEVER KNOWINGLY OPERATES IN SUCH A WAY AS TO LESSEN THE PLEASURE OF OTHERS BK LOYAL THE RADIO AMATEUR OFFERS LOYALTY ENCOURAGEMENT AND SUPPORT TO OTHER AMATEURS LOCAL CLUBS THE IARU RADIO SOCIETY IN THEIR COUNTRY THROUGH WHICH AMATEUR RADIO IN THEIR COUNTRY IS REPRESENTED NATIONALLY AND INTERNATIONALLY BK PROGRESSIVE THE RADIO AMATEUR KEEPS THEIR STATION UP TO DATE IT IS WELL BUILT AND EFFICIENT THEIR OPERATING PRACTICE IS ABOVE REPROACH BK FRIENDLY THE RADIO AMATEUR OPERATES SLOWLY AND PATIENTLY WHEN REQUESTED OFFERS FRIENDLY ADVICE AND COUNSEL TO BEGINNERS KIND ASSISTANCE COOPERATION AND CONSIDERATION FOR THE INTERESTS OF OTHERS THESE ARE THE MARKS OF THE AMATEUR SPIRIT BK BALANCED RADIO IS A HOBBY NEVER INTERFERING WITH DUTIES OWED TO FAMILY JOB SCHOOL OR COMMUNITY BK PATRIOTIC THE RADIO AMATEUR'S STATION AND SKILLS ARE ALWAYS READY FOR SERVICE TO COUNTRY AND COMMUNITY BK`,
        estimatedSeconds: { wpm15: 360, wpm20: 270, wpm25: 215 },
        questions: [
            {
                id: 'amateurs-code-q1',
                question: "According to the 'Balanced' principle, what should the hobby never interfere with?",
                options: ['PERSONAL REPUTATION', 'FAMILY, JOB, SCHOOL, OR COMMUNITY', 'OTHER AMATEUR RADIO STATIONS', 'THE SEARCH FOR NEW TECHNOLOGY'],
                answer: 'FAMILY, JOB, SCHOOL, OR COMMUNITY',
                difficulty: 'Beginner'
            },
            {
                id: 'amateurs-code-q2',
                question: 'According to the code, what is a mark of the "amateur spirit"?',
                options: ['OPERATING AS FAST AS POSSIBLE', 'FRIENDLY ADVICE AND CONSIDERATION', 'BUILDING THE MOST EXPENSIVE STATION', 'INTERFERING WITH FAMILY DUTIES'],
                answer: 'FRIENDLY ADVICE AND CONSIDERATION',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'story-amateurs-code',
    type: 'story',
    title: "The Amateur's Code",
    author: 'Paul M. Segal, W9EEA',
    publicationDate: '1928',
    coverImage: coverImg,
    genres: ['Ethics', 'Ham Radio', 'History'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "The classic code of conduct for radio amateurs, outlining the core principles that define the amateur spirit.",
    isNew: true,

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'Global Amateur Radio Community',
        period: '1928',
        themes: ['Ethics', 'Volunteer Service', 'Technical Excellence'],
        difficulty: 'Beginner',
        estimatedReadingTimeMinutes: 5,
        segments: 1
    }
};
